import React, { useState } from 'react'

import { ExitPrompt, ExitPromptType } from '@frame/ui-components/exit-prompt'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { H2 } from '@frame/ui-primitives/h2'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { useStore } from '@frame/lib/stores/useStore'
import { DataAttribute } from '@frame/types'

import { TaskFooter } from '../../components/task-footer'
import { TenantTaskContent } from './tenant-task-content'

type Props = {
  tasks: DirectTask[]
}

export function TenantScreeningTasks({ tasks }: Props) {
  const isMultiTaskSession = useStore(({ session }) => Boolean((session?.max_employments || 1) > 1))
  const showExitPrompt = useShowExitPrompt()

  const [showIncompletePrompt, setShowIncompletePrompt] = useState(false)

  const heading = isMultiTaskSession ? 'Complete your tasks' : 'Select the option that best describes you'

  return (
    <>
      <WidgetHeaderWithNavigation showCobranding backButton={{ visible: false }} showExitPrompt={showExitPrompt} />
      <Body data-cy={DataAttribute.TENANT_SCREENING_TASKS} className="p-5" paddingTopOverride={8}>
        <H2 className="mb-4 text-left text-moss-700">{heading}</H2>
        <TenantTaskContent tasks={tasks} />
      </Body>
      <ExitPrompt
        show={showIncompletePrompt}
        hide={() => setShowIncompletePrompt(false)}
        title="Submit incomplete tasks?"
        type={ExitPromptType.INCOMPLETE}
      />
      <TaskFooter setShowIncompletePrompt={setShowIncompletePrompt} directTasks={tasks} />
    </>
  )
}
